import { render, staticRenderFns } from "./select-company-modal.vue?vue&type=template&id=5c505134&scoped=true"
import script from "./select-company-modal.vue?vue&type=script&lang=js"
export * from "./select-company-modal.vue?vue&type=script&lang=js"
import style0 from "./select-company-modal.vue?vue&type=style&index=0&id=5c505134&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c505134",
  null
  
)

export default component.exports